import { atom } from 'jotai'

export const reminderIdAtom = atom<string>('0000')
